export const enum MedicationHistoryTabKeys {
    Medsheets = 1,
    FulfilledMedications = 2,
    DiscontinuedMedications = 3
}